<span class="author-name nordic-blue-900-text text-icon-primary font-label-medium">{{ author() }}</span>
